import { MarketingNav, Footer } from "@/components/marketing/MarketingNav";
import { Link } from "react-router-dom";
import { StatusBadge } from "@/components/common";
import { ArrowRight, Activity, Layers, Target, Scale, Bell, BookOpen, Brain, Newspaper, ShieldCheck } from "lucide-react";

const BLOCKS = [
  { icon: Activity, t: "Market Regime", d: "Trend, range, compression, breakout, expansion or unclear — classified deterministically. When evidence conflicts, Aurum says UNCLEAR and waits." },
  { icon: Layers, t: "Multi-Timeframe", d: "4H macro bias, 1H structure, 15M setup, 5M trigger — combined into one honest overall assessment." },
  { icon: Target, t: "Key Levels & Setups", d: "Automatic support/resistance ranked MAJOR/MODERATE/MINOR, with flagship pullback setup detection and confirmation requirements." },
  { icon: Scale, t: "Risk Engine", d: "Structure-based stops, logical TP1/TP2/TP3, exact gold position sizing, dynamic risk reduction, and a hard circuit breaker." },
  { icon: Brain, t: "Devil's Advocate", d: "Case for and against every trade, plus 'what would change my mind?' — engineered to reduce confirmation bias." },
  { icon: Newspaper, t: "News Protection", d: "High-impact USD/Gold events with countdowns. Around major releases, new entry validation pauses per your plan." },
  { icon: Bell, t: "Entry Alerts", d: "A clear state machine: NO TRADE → WATCH → SETUP FORMING → WAITING FOR CONFIRMATION → ENTRY CONDITIONS SATISFIED." },
  { icon: BookOpen, t: "Journal & Analytics", d: "Automatic journaling, full performance breakdowns, and an AI coach that respects sample size." },
];

export default function Product() {
  return (
    <div className="bg-[var(--bg)] text-[var(--text)] min-h-screen">
      <MarketingNav />
      <section className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-20">
        <span className="text-xs uppercase tracking-wider text-aurum font-medium">The product</span>
        <h1 className="mt-3 text-4xl lg:text-5xl font-extrabold tracking-tight max-w-3xl">Institutional market intelligence for a single trader.</h1>
        <p className="mt-5 text-lg text-[var(--text-sec)] max-w-2xl">
          Every number Aurum shows is computed by deterministic engines. The AI explains, teaches
          and challenges — it never invents prices, indicators or risk.
        </p>
        <div className="mt-6 flex flex-wrap gap-2">
          {["NO TRADE", "WATCH", "SETUP FORMING", "ENTRY CONDITIONS SATISFIED", "NEWS PROTECTION ACTIVE"].map((s) => <StatusBadge key={s} status={s} />)}
        </div>
        <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {BLOCKS.map((b) => (
            <div key={b.t} className="rounded-xl border border-[var(--border2)] bg-[var(--card2)] p-6">
              <b.icon size={20} className="text-aurum" />
              <h3 className="mt-4 font-semibold">{b.t}</h3>
              <p className="mt-2 text-sm text-[var(--text-sec)]">{b.d}</p>
            </div>
          ))}
        </div>
        <div className="mt-12 rounded-2xl border border-[var(--border2)] bg-[var(--bg-elev)] p-8 flex items-center justify-between flex-wrap gap-4">
          <div className="flex items-center gap-3"><ShieldCheck className="text-aurum" /><p className="text-sm text-[var(--text-sec)] max-w-lg">No autonomous live-money trading in the first release. Paper trading and monitoring only — safety first.</p></div>
          <Link to="/signup" className="btn-gold flex items-center gap-2 rounded-full px-6 py-3 text-sm font-semibold hover:brightness-110">Start free <ArrowRight size={16} /></Link>
        </div>
      </section>
      <Footer />
    </div>
  );
}
